import * as React from 'react'
import TenantEdit from 'Components/templates/TenantEdit'

export default function TenantEditScreen() {
    return <TenantEdit />
}
